define('cartware/components/Dispatcher',[
	"./Utilities",
	"./FeatureFlagged"
], function(
	Utils,
	FeatureFlagged
) {
	var _sharedAppliedComponents = [],
		_allAppliedComponents = {
			components: [],
			instances: []
		};

	function Dispatcher(options) {
		this._appliedComponents	= ("useSharedComponentPool" in options) ? _sharedAppliedComponents : [];
		this._handles			= ("handles" in options) ? options.handles : [];
		this._featureFlags		= ("featureFlags" in options) ? options.featureFlags : {};

		if ("apply" in options) {
			this.applyHandles(options.apply);
		}
	}

	Dispatcher.prototype = {
		_appliedComponents:	null,
		_handles:			null,

		getHandles: function() {
			return this._handles;
		},

		setHandles: function(handles) {
			this.handles = handles;
			return this;
		},

		applyHandles: function(handlesMap, callback) {
			var self = this;
			var handle, components, innerKey, component;

			for (handle in handlesMap) {
				if (handlesMap.hasOwnProperty(handle)) {
					components = handlesMap[handle];
					if (self._handles.indexOf(handle) >= 0) {
						for (innerKey in components) {
							if (components.hasOwnProperty(innerKey)) {
								// Feature flagged component
								if (components[innerKey] instanceof FeatureFlagged) {
									if (!_.every(components[innerKey].getFlags(), function(flag) {
										return (flag in self._featureFlags && self._featureFlags[flag]);
									})) {
										return;
									}

									self.initializeComponent(components[innerKey].getComponent(), callback);
								}
								// Normal component
								else {
									self.initializeComponent(components[innerKey], callback);
								}
							}
						}
					}
				}
			}
		},

		initializeComponent: function(component, callback) {
			var self = this;

			if ("string" === typeof component) {
				require([component], function(c) { self.initializeComponent(c, callback); });
				return;
			}

			if (self._appliedComponents.indexOf(component) < 0) {
				var allComponentsIndex = _allAppliedComponents.components.indexOf(component);

				if (allComponentsIndex >= 0) {
					var oldInstance = _allAppliedComponents.instances[allComponentsIndex];

					if ("function" === typeof oldInstance.destructor) {
						oldInstance.destructor();
					}

					Array.prototype.splice.call(_allAppliedComponents.components, allComponentsIndex, 1);
					Array.prototype.splice.call(_allAppliedComponents.instances, allComponentsIndex, 1);
				}

				var c = new component();

				if ("undefined" !== typeof c.init) {
					c.init();
				}

				if ("undefined" !== typeof c.$init) {
					require(["jquery"], function($) {
						$($.proxy(c.$init, c));
					});
				}

				self._appliedComponents.push(component);

				_allAppliedComponents.components.push(component);
				_allAppliedComponents.instances.push(c);
			}

			if (callback) {
				callback.apply(null, [
					_allAppliedComponents.instances[_allAppliedComponents.components.indexOf(component)]
				]);
			}
		}
	};

	return Dispatcher;
});
